<template>
   <Map :eventId="eventId"></Map>
</template>
<script>
import Map from '@/components/airbox/BoxMap.vue'

export default {
  name: 'Lsb',
  data () {
    return {
      tab: null,
      items: [
        { tab: "Mobile view", content: "Tab 1 Content", nr: 1 },
        { tab: "Table view", content: "Tab 2 Content", nr: 2 }
      ],
      eventId: 0
    };
  },
  created() {
    // let uri = window.location.search.substring(1);
    // let params = new URLSearchParams(uri);
    // this.eventId = params.get("eventId");
    this.eventId = this.$route.params.eventId;
  },
  components: {
    Map
  }
}
</script>